<swiper [config]="configSwiper" *ngIf="charge === true && !imagesOnly && !videoOnly">
    <div *ngFor="let product of arrayProducts; let i = index">
        <app-new-product-card [ifAdvertisedModal]="ifAdvertisedModal" [idPrefix]="idPrefix" [product]="product" [isMini]="miniCard" [isHome]="isHome" [lazyLoaded]="lazyLoad" [discountsLoaded]="discountsLoaded"></app-new-product-card>
    </div>
</swiper>


<swiper [config]="configSwiper" *ngIf="imagesOnly">
    <div *ngFor="let item of arrayProducts" class="slide">
        <div class="cont-img-publicity">
            <a [routerLink]="item.url">
                <img class="img" [src]="item.img" [alt]="item.title">
            </a>
        </div>
    </div>
</swiper>

<swiper [config]="configSwiper" *ngIf="videoOnly">
    <div *ngFor="let item of arrayProducts" class="slide" (click)="goTo(item)">
        <div class="cont-video-publicity">
            <div class="cont-img">
                <img class="img" [src]="item.thumbnail" [alt]="item.title">
                <app-icons class="icon-arrow" [type]="'arrow-fill'" [custom]="'rigth lg'"></app-icons>
            </div>
            <p class="title-video">{{item.title | titlecase}}</p>
        </div>
    </div>
</swiper>